import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getUserTips,
  markUserTipsPaid,
  patchTipStatus,
} from '../../../helpers/tip_helper';

// Napiwki wskazanego club admina — widok głównego administratora
export const fetchUserTips = createAsyncThunk(
  'adminUserTips/fetch',
  async (userId, { rejectWithValue }) => {
    try {
      return await getUserTips(userId);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || error);
    }
  }
);

/**
 * Oznacza napiwki jako wypłacone.
 * @param {string} userId
 * @param {number[]|null} ids - null oznacza "wszystkie nierozliczone"
 */
export const markTipsPaid = createAsyncThunk(
  'adminUserTips/markPaid',
  async ({ userId, ids = null }, { rejectWithValue }) => {
    try {
      return await markUserTipsPaid(userId, ids);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || error);
    }
  }
);

export const setTipStatus = createAsyncThunk(
  'adminUserTips/setStatus',
  async ({ id, status }, { rejectWithValue }) => {
    try {
      return await patchTipStatus(id, status);
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || error);
    }
  }
);
